


import 'babel-polyfill'
import 'es6-promise/auto'

import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/css/base.css'


import store from './store'

import ToastPlugin from 'vux/src/plugins/toast/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import WechatPlugin from 'vux/src/plugins/wechat/index.js'

Vue.use(ToastPlugin)
Vue.use(AlertPlugin)
Vue.use(ConfirmPlugin)
Vue.use(WechatPlugin)


import ajax from './api/ajax'
Vue.prototype.$ajax = ajax


import FastClick from 'fastclick'

FastClick.attach(document.body)


import urls from './api/apiUrls'
Vue.prototype.$apiUrls = urls

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
el: '#app',
store,
router,
components: { App },
template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js